module.exports = __webpack_public_path__ + "files/657216a50d61c5a61728ca114a01c724.png";